import React from 'react'
import { JobWizard } from 'sprockets_react/job_wizards/registries'

JobWizard.JobPostingForm = function({stepComponent}) {
  return(
    <form id="job_form">
        { stepComponent }
    </form>
  )
}
